import { create } from '@thoughtspot/logger';
import Joi from 'joi';
import { getLDFlagsFromEventData } from './utils';
const logger = create('ts-to-chart > event-callbacks > get-blink-flags');
const schema = Joi.object({
    flags: Joi.array()
        .items(Joi.string()
        .max(80)
        .trim())
        .required()
        .allow()
        .empty(),
});
export const validateLDFlagEventsPayload = (eventData) => {
    try {
        Joi.assert(eventData.payload, schema);
    }
    catch (err) {
        logger.warn(err);
        return {
            isValid: false,
            errors: [err.toString()],
        };
    }
    return {
        isValid: true,
    };
};
const getLDFlagEventProcessor = (props) => {
    return {
        validateEventPayload: (eventData) => {
            return validateLDFlagEventsPayload(eventData);
        },
        executeEvent: async (eventData) => {
            const res = getLDFlagsFromEventData(eventData.payload.flags);
            return Promise.resolve(res);
        },
    };
};
export { getLDFlagEventProcessor };
//# sourceMappingURL=index.js.map